export class RegistrationSourceDto {
  constructor(dto) {
    this.id = dto.id;
    this.name = dto.name;
  }
}
